import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Motion, presets } from '../motion';

const inp = { background: '#0d0d0d', border: '1px solid #2a2a2a', borderRadius: '12px', padding: '13px 16px', color: '#f0f0f0', fontFamily: 'inherit', fontSize: '14px', outline: 'none', width: '100%', boxSizing: 'border-box' };

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <Motion {...presets.rise} style={{ minHeight: '100vh', background: '#000', padding: '40px 24px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div style={{ fontFamily: 'Nunito', fontSize: '36px', fontWeight: 900, letterSpacing: '3px', color: '#9b5de5', marginBottom: '8px' }}>
        BLOBL
      </div>
      <p style={{ color: '#555', marginBottom: '32px' }}>Reset your password</p>

      {sent ? (
        <div style={{ background: 'rgba(155,93,229,0.08)', border: '1px solid rgba(155,93,229,0.2)', borderRadius: '12px', padding: '18px 20px', color: '#c084fc', fontSize: '14px', lineHeight: 1.6 }}>
          If an account with that email exists, we've sent a reset link. Check your inbox.
        </div>
      ) : (
        <>
          {error && (
            <div style={{ color: '#f43f5e', marginBottom: '16px', fontSize: '13px', background: 'rgba(244,63,94,0.08)', border: '1px solid rgba(244,63,94,0.2)', borderRadius: '10px', padding: '10px 14px' }}>
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={inp}
            />
            <button
              type="submit"
              disabled={loading}
              style={{ background: 'linear-gradient(135deg, #9b5de5, #7c3aed)', border: 'none', borderRadius: '25px', padding: '14px', color: 'white', fontFamily: 'Nunito', fontSize: '14px', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
            >
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        </>
      )}

      <p style={{ marginTop: '24px', textAlign: 'center', fontSize: '14px' }}>
        <Link to="/login" style={{ color: '#c084fc', textDecoration: 'none' }}>Back to login</Link>
      </p>
    </Motion>
  );
}
